import { Component, input, output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TaskDetailsSubtaskItemComponent } from '@app/components/task/task-splitview-list/task-details-content/task-details-subtask-item/task-details-subtask-item.component';
import { TaskPriority } from '@app/shared/types/enums/task-priority.enum';
import { TaskStatus } from '@app/shared/types/enums/task-status.enum';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiCardComponent } from '@app/shared/ui/card/ui-card.component';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * @summary Task detail subtasks section — desktop accordion and mobile list below Description tab.
 * @selector proffeo-task-details-subtasks-section
 */
@Component({
  selector: 'proffeo-task-details-subtasks-section',
  templateUrl: './task-details-subtasks-section.component.html',
  styleUrl: './task-details-subtasks-section.component.scss',
  imports: [
    MatExpansionModule,
    MatIconModule,
    UiButtonComponent,
    TaskDetailsSubtaskItemComponent,
    TranslatePipe,
    UiCardComponent
  ]
})
export class TaskDetailsSubtasksSectionComponent {
  public readonly task = input.required<Task>();
  public readonly subtasks = input.required<Task[]>();
  public readonly isMobile = input.required<boolean>();
  public readonly showTaskSubtasksPanel = input.required<boolean>();
  public readonly isTaskSubtasksPanelContentVisible = input.required<boolean>();

  public readonly addSubtaskFromPanel = output<MouseEvent>();
  public readonly desktopPanelExpandedChange = output<boolean>();
  public readonly subtaskClick = output<Task>();
  public readonly addTimeReport = output<Task>();
  public readonly statusChanged = output<{ status: TaskStatus; subtask: Task }>();
  public readonly priorityChanged = output<{ priority: TaskPriority; subtask: Task }>();
  public readonly progressChanged = output<{ percentage: number; subtask: Task }>();
}
